
import { PhoneNumberUtil} from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();


function validarTelefoneBR(onlyNumbers: string): { numero: string; erro: string | null } {
  if (onlyNumbers.startsWith("55")) onlyNumbers = onlyNumbers.substring(2);

  if (onlyNumbers.length === 8) {
    onlyNumbers = "9" + onlyNumbers;
  }
  if (onlyNumbers.length === 8 || onlyNumbers.length === 9) {
    onlyNumbers = "11" + onlyNumbers;
  }
  return { numero: "+55" + onlyNumbers, erro: null };
}


function validarTelefonePT(onlyNumbers: string): { numero: string; erro: string | null } {
  if (onlyNumbers.startsWith("351")) onlyNumbers = onlyNumbers.substring(3);  
  if (onlyNumbers.length > 9) onlyNumbers = onlyNumbers.substring(0, 9);
  if (onlyNumbers.length < 9) return { numero: "", erro: "Número inválido" };
  
  return { numero: "+351" + onlyNumbers, erro: null };
}

export function validarTelefone(numero: string, countryCode: string): string | null {
  let onlyNumbers = numero.replaceAll(/\D/g, "");
  let erro: string | null = null;

  if (countryCode === "BR") {
    const result = validarTelefoneBR(onlyNumbers);
    if (result.erro) return result.erro;
    numero = result.numero;
  } else if (countryCode === "PT") {
    const result = validarTelefonePT(onlyNumbers);
    if (result.erro) return result.erro;
    numero = result.numero;
  }

  try {
    const parsedNumber = phoneUtil.parse(numero);
    if (!phoneUtil.isValidNumber(parsedNumber)) {
      return "Número inválido";
    } 
    return null;
  } catch (error) {
    console.error("Erro ao validar o número de telefone:", error);
    return "Número inválido";
  }
}